var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row form-group mt-3 mb-4 text-area-row" },
    [
      _c(
        "div",
        {
          staticClass: "d-flex flex-column align-items-start col-xs-12 col-sm-5"
        },
        [
          _vm.title
            ? _c(
                "label-control",
                {
                  staticClass: "col-form-label",
                  attrs: {
                    forElement: _vm.id,
                    title: _vm.title,
                    required: _vm.required
                  }
                },
                [_vm._v(_vm._s(_vm.$t(_vm.title)))]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "button",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip.top.center",
                  value: { html: true, content: _vm.$t(_vm.buttonTooltip) },
                  expression: "{html: true, content: $t(buttonTooltip)}",
                  modifiers: { top: true, center: true }
                }
              ],
              staticClass: "btn btn-secondary",
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.showDialog()
                }
              }
            },
            [
              _c("span", [
                _vm._v(
                  _vm._s(_vm.$t("ContinuousReportSummary.Notes.ViewNotes"))
                )
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "sr-only" }, [
                _vm._v(_vm._s(_vm.$t(_vm.buttonTooltip)))
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: [
            _vm.title
              ? "col-xs-12 col-sm-7"
              : _vm.inputWidth
              ? _vm.inputWidth
              : "col-12"
          ]
        },
        [
          _c("text-area-control", {
            class: ["form-control", _vm.textAreaClasses],
            attrs: {
              id: _vm.id,
              placeholderKey: _vm.placeholder,
              required: _vm.required,
              maxLength: _vm.maxLength,
              rows: _vm.rows,
              "aria-required": _vm.required,
              rules: _vm.rules,
              disabled: _vm.isDisabled,
              labelledBy: _vm.ariaLabelId,
              noResize: _vm.noResize,
              showMaxLengthInPlaceholder: _vm.showMaxLengthInPlaceholder
            },
            on: {
              blur: function($event) {
                return _vm.$emit("blur")
              }
            },
            model: {
              value: _vm.modifiedValue,
              callback: function($$v) {
                _vm.modifiedValue = $$v
              },
              expression: "modifiedValue"
            }
          }),
          _vm._v(" "),
          !_vm.isDisabled
            ? _c("div", { staticClass: "text-area-info-row" }, [
                !_vm.hideCharsLeft
                  ? _c("div", { staticClass: "float-right" }, [
                      _c("small", [
                        _vm._v(
                          _vm._s(_vm._f("formatNumber")(_vm.charsLeft)) +
                            " " +
                            _vm._s(_vm.$t("CharsLeft"))
                        )
                      ])
                    ])
                  : _vm._e()
              ])
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("notes-dialog-control", {
        attrs: { id: _vm.dialogId, notes: _vm.notes }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }